import { AppConfig } from '@neptune/config-core-domain';

import config from 'config';

class NeptuneUrls {
  constructor(private config: AppConfig) {}

  private get docsFallback(): string {
    return `${this.config.documentationURL}/index.html`;
  }

  get documentation(): string {
    return this.config.documentationURL;
  }

  get apiDocumentation(): string {
    return `${this.config.documentationURL}/api/query_api_overview.html`;
  }

  get archivingProjectsDoc(): string {
    return this.docsFallback;
  }

  get salesEmail(): string {
    return this.config.salesEmail;
  }

  get supportEmail(): string {
    return this.config.supportEmail;
  }

  get supportUrl(): string {
    return this.config.supportUrl;
  }

  get customDashboardDoc(): string {
    return `${this.config.documentationURL}/app/dashboards/overview.html`;
  }

  get groupByDoc(): string {
    return `${this.config.documentationURL}/app/manage_runs/grouping.html`;
  }

  get loggingMetricsDoc(): string {
    return `${this.config.documentationURL}/metrics.html`;
  }

  get troubleshootingRateLimiting(): string {
    return this.docsFallback;
  }

  get pricing(): string {
    return this.config.pricingURL;
  }

  get integrationQuickStartDocs(): string {
    return `${this.config.integrationQuickStartURL}`;
  }

  get reportsDoc(): string {
    return `${this.config.documentationURL}/app/reports/overview.html`;
  }

  get reportDslDoc(): string {
    return `${this.config.documentationURL}/app/reports/edit_a_report_as_json_dsl/index.html`;
  }

  get settingProjectNameDoc(): string {
    return `${this.config.documentationURL}/concepts.html#project`;
  }

  get setupApiTokenDoc(): string {
    return `${this.config.documentationURL}/management/api_tokens.html`;
  }

  get statusPage(): string | undefined {
    return this.config.statusPageUrl;
  }

  get workspaceOrProjectReadOnlyDoc(): string {
    return `${this.config.documentationURL}/management/manage_users_and_access.html`;
  }

  get workspaceReadOnlyDoc(): string {
    return `${this.config.documentationURL}/management/manage_users_and_access.html`;
  }

  get workspacesAndProjectsDoc(): string {
    return `${this.config.documentationURL}/concepts.html#project`;
  }

  get dynamicSelection(): string {
    return `${this.config.documentationURL}/app/charts/chart_widget.html#select-metrics-dynamically`;
  }

  get getCustomExpressions(): string {
    return `${this.config.documentationURL}/app/charts/chart_widget.html#create-a-custom-expression`;
  }

  get getSecondaryStyling(): string {
    return `${this.config.documentationURL}/app/charts/overview.html#secondary-styling-rules-for-metrics`;
  }

  get regexCompoundExpressions(): string {
    return `${this.config.documentationURL}/regex_reference.html#compound-expressions`;
  }

  get pointPreviews(): string {
    return `${this.config.documentationURL}/metrics.html#show-or-hide-preview-points-in-charts`;
  }

  get speedTest(): string {
    return `${window.location.origin}/services/speedtest/`;
  }
}

export const neptuneUrls = new NeptuneUrls(config);
